module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3TAEC"))).then(() => module.bundle.root('1iHdE'));